import React from 'react';
import { useLoginInfo } from 'hooks/useLoginInfo';

export const withLoginInfo = <P extends {}>(Component: React.ComponentType<P>) => {
  type InstType = React.ComponentType<Omit<P, 'loginInfo'>>;
  return React.forwardRef<InstType, Omit<P, 'loginInfo'>>(function WithLoginInfo(props, ref) {
    const loginInfo = useLoginInfo();
    const Comp: any = Component;
    return <Comp ref={ref} loginInfo={loginInfo} {...props} />;
  });
};
